import { getValueByPath } from 'element-ui/lib/utils/util'

export default {
  computed: {
    rowClassName: function () {
      let rowList = this.rowList
      if (rowList) {
        return rowList.map(data => this.buildRowClassName(data))
      }
    }
  },
  methods: {
    buildRowClassName (rowData) {
      let buildRowClass
      if (this.gridConfig) {
        let rowMatcher = this.gridConfig['rowMatcher']
        if (rowMatcher) {
          rowMatcher.some((rowMatcherItem) => {
            let columnMatcher = rowMatcherItem['columnMatcher']
            if (columnMatcher) {
              for (let index = 0; index < columnMatcher.length; index++) {
                let columnMatcherItem = columnMatcher[index]
                let cellValue = getValueByPath(rowData, columnMatcherItem.prop) || ''
                // 必须是全匹配
                let cellRegex = new RegExp('^' + columnMatcherItem.regex + '$')
                if (cellRegex.test(cellValue)) {
                  if (index === columnMatcher.length - 1) {
                    buildRowClass = this.getRowThemeClass(rowMatcherItem['themeType'])
                  }
                } else {
                  break
                }
              }
            }
          })
        }
      }
      return buildRowClass
    },
    // 获取行风格样式
    getRowThemeClass (themeType) {
      if (themeType) {
        return 'grid-row-' + themeType
      } else {
        return ''
      }
    }
  }
}
